module.exports = __webpack_public_path__ + "img/young-woman-working-from-modern-home.0f163df9.jpg";